export function extractLithuanianLocalNumber(phone?: Nullable<string>): string {
    if (!phone) return '';

    let digits = phone.replace(/\D/g, '');
    if (digits.startsWith('370')) {
        digits = digits.slice(3);
    } else if (digits.startsWith('0')) {
        digits = digits.slice(1);
    }

    return digits.slice(0, 8);
}
